import { firestoreAction } from "vuexfire";
import "firebase/firestore";
import { db } from "@/services/firebase.service";
import isEmpty from "lodash/isEmpty";
import store from "@/store";

export default {
    createConstruction({ commit }, constructionData) {
        commit("ADD_CONSTRUCTION", constructionData);
    },

    createInstallationTech({ commit }, techInstallation) {
        commit("ADD_TECH_INSTALLATION", techInstallation);
    },

    removeConstruction({ commit }, id) {
        commit("REMOVE_CONSTRUCTION", id);
    },

    removeInstallationTech({ commit }, id) {
        commit("REMOVE_TECH_INSTALLATION", id);
    },

    addLabourCard({ commit }, labourCard) {
        commit("ADD_LABOUR", labourCard);
    },

    createTools({ commit }, tools) {
        commit("ADD_TOOLS", tools);
    },
    removeTool({ commit }, id) {
        commit("REMOVE_TOOLS", id);
    },

    createTransportation({ commit }, transportation) {
        commit("ADD_TRANSPORTATION", transportation);
    },
    removeTransportation({ commit }, id) {
        commit("REMOVE_TRANSPORTATION", id);
    },
    addFurnitureCard({ commit }, furnitureCard) {
        commit("ADD_FURNITURE_CARD", furnitureCard);
    },
    removeFurniture({ commit }, id) {
        commit("REMOVE_FURNITURE_CARD", id);
    },
    addTechHardware({ commit }, techHardware) {
        commit("ADD_TECH_HARDWARE", techHardware);
    },
    addITMO({ commit }, itmo) {
        commit("ADD_ITMO", itmo);
    },
    removeHardware({ commit }, id) {
        commit("REMOVE_TECH_HARDWARE", id);
    },
    removeITMO({ commit }, id) {
        commit("REMOVE_ITMO", id);
    },

    putConstructionData({ commit }, constructionData) {
        commit("PUT_CONSTRUCTION_DATA", constructionData);
    },

    putTechInstallations({ commit }, techInstallations) {
        commit("PUT_TECH_INSTALLATIONS", techInstallations);
    },

    putLabourCard({ commit }, labourCard) {
        commit("PUT_LABOUR_CARD", labourCard);
    },

    putTools({ commit }, tools) {
        commit("PUT_TOOLS", tools);
    },

    putTransportation({ commit }, transportation) {
        commit("PUT_TRANSPORTATION", transportation);
    },

    putFurnitureCard({ commit }, furnitureCard) {
        commit("PUT_FURNITURE_CARD", furnitureCard);
    },

    putTechHardware({ commit }, techHardware) {
        commit("PUT_TECH_HARDWARE", techHardware);
    },
    putITMO({ commit }, itmo) {
        commit("PUT_ITMO", itmo);
    },

    SaveConstructionData: firestoreAction(
        ({ state, rootState, rootGetters }) => {
            if (
                !isEmpty(
                    rootState.EtudeFinanciere
                        .programmeDinvestissementPlanDeFinancement
                )
            ) {
                store.dispatch(
                    "EtudeFinanciere/saveEditedInvestorsProgrammeConstruction"
                );
            }

            if (!isEmpty(rootState.EtudeFinanciere.autresCharges)) {
                store.dispatch("EtudeFinanciere/saveEditedOtherCharge");
            }

            if (!rootGetters["user/isSimplifiedVersion"]) {
                db.collection("bpis")
                    .doc(`${rootState.user.bpiId}`)
                    .update({
                        Moyens_fonciers_et_immeubles: state.constructionsData,
                        current_step: rootGetters["user/getLastStep"](
                            "Moyens d’exploitation"
                        ),
                        current_Substep: rootGetters["user/getLastSubStep"](
                            "Installations techniques"
                        )
                    })
                    .then(() => {});
            } else {
                db.collection("bpis")
                    .doc(`${rootState.user.bpiId}`)
                    .update({
                        Moyens_fonciers_et_immeubles: state.constructionsData,
                        current_step: rootGetters["user/getLastStep"](
                            "Moyens d’exploitation"
                        )
                    })
                    .then(() => {});
            }
        }
    ),

    SaveTechInstallations: firestoreAction(
        ({ state, rootState, rootGetters }) => {
            if (
                !isEmpty(
                    rootState.EtudeFinanciere
                        .programmeDinvestissementPlanDeFinancement
                )
            ) {
                store.dispatch(
                    "EtudeFinanciere/saveEditedInvestorsProgrammetechInstallations"
                );
            }
            if (!isEmpty(rootState.EtudeFinanciere.autresCharges)) {
                store.dispatch("EtudeFinanciere/saveEditedOtherCharge");
            }

            db.collection("bpis")
                .doc(`${rootState.user.bpiId}`)
                .update({
                    installations_techniques: state.techInstallations,
                    current_step: rootGetters["user/getLastStep"](
                        "Moyens d’exploitation"
                    ),
                    current_Substep: rootGetters["user/getLastSubStep"](
                        "Matériels et outillage"
                    )
                })
                .then(() => {});
        }
    ),

    SaveTools: firestoreAction(({ state, rootState, rootGetters }) => {
        if (
            !isEmpty(
                rootState.EtudeFinanciere
                    .programmeDinvestissementPlanDeFinancement
            )
        ) {
            store.dispatch(
                "EtudeFinanciere/saveEditedInvestorsProgrammetechtools"
            );
        }
        if (!isEmpty(rootState.EtudeFinanciere.autresCharges)) {
            store.dispatch("EtudeFinanciere/saveEditedOtherCharge");
        }

        db.collection("bpis")
            .doc(`${rootState.user.bpiId}`)
            .update({
                materiels_et_outillage: state.tools,
                current_step: rootGetters["user/getLastStep"](
                    "Moyens d’exploitation"
                ),
                current_Substep: rootGetters["user/getLastSubStep"](
                    "Moyens de transports et manutentions"
                )
            })
            .then(() => {});
    }),

    SaveTransportation: firestoreAction(({ state, rootState, rootGetters }) => {
        if (
            !isEmpty(
                rootState.EtudeFinanciere
                    .programmeDinvestissementPlanDeFinancement
            )
        ) {
            store.dispatch(
                "EtudeFinanciere/saveEditedInvestorsProgrammetechtransportation"
            );
        }

        if (!isEmpty(rootState.EtudeFinanciere.autresCharges)) {
            store.dispatch("EtudeFinanciere/saveEditedOtherCharge");
        }

        db.collection("bpis")
            .doc(`${rootState.user.bpiId}`)
            .update({
                moyens_de_transports_et_manutentions: state.transportation,
                current_step: rootGetters["user/getLastStep"](
                    "Moyens d’exploitation"
                ),
                current_Substep: rootGetters["user/getLastSubStep"](
                    "Mobilier et bureaux"
                )
            })
            .then(() => {});
    }),

    SaveFurniture: firestoreAction(({ state, rootState, rootGetters }) => {
        if (
            !isEmpty(
                rootState.EtudeFinanciere
                    .programmeDinvestissementPlanDeFinancement
            )
        ) {
            store.dispatch(
                "EtudeFinanciere/saveEditedInvestorsProgrammetechfurniture"
            );
        }

        db.collection("bpis")
            .doc(`${rootState.user.bpiId}`)
            .update({
                mobilier_et_bureaux: state.furnitureCard,
                current_step: rootGetters["user/getLastStep"](
                    "Moyens d’exploitation"
                ),
                current_Substep: rootGetters["user/getLastSubStep"](
                    "Matériel Informatique"
                )
            })
            .then(() => {});
    }),

    SaveTechHardware: firestoreAction(({ state, rootState, rootGetters }) => {
        if (
            !isEmpty(
                rootState.EtudeFinanciere
                    .programmeDinvestissementPlanDeFinancement
            )
        ) {
            store.dispatch(
                "EtudeFinanciere/saveEditedInvestorsProgrammetechtechHardware"
            );
        }

        db.collection("bpis")
            .doc(`${rootState.user.bpiId}`)
            .update({
                materiel_informatique: state.techHardware,
                current_step: rootGetters["user/getLastStep"]("Moyens humains")
            })
            .then(() => {});
    }),
    SaveITMO: firestoreAction(({ state, rootState, rootGetters }) => {
        if (
            !isEmpty(
                rootState.EtudeFinanciere
                    .programmeDinvestissementPlanDeFinancement
            )
        ) {
            store.dispatch(
                "EtudeFinanciere/saveEditedInvestorsProgrammetechITMO"
            );
        }

        db.collection("bpis")
            .doc(`${rootState.user.bpiId}`)
            .update({
                itmo: state.itmo,
                current_step: rootGetters["user/getLastStep"]("Moyens humains")
            })
            .then(() => {});
    }),

    SaveLabours: firestoreAction(({ state, rootState, rootGetters }) => {
        db.collection("bpis")
            .doc(`${rootState.user.bpiId}`)
            .update({
                moyens_humains: state.labourCard,
                current_step: rootGetters["user/getLastStep"](
                    "Programme d’investissement plan de financement"
                )
            })
            .then(() => {});
    })
};
